var _g, _ellipse, _path, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92mm",
    height: "67mm",
    viewBox: "0 0 92 67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 117.98 -83.435)",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.326,
    y: 85.443,
    width: 70.774,
    height: 43.059,
    ry: 12.041,
    opacity: 0.86,
    strokeWidth: 0.19811
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.121,
    y: 92.293,
    width: 34.48,
    height: 33.273,
    ry: 12.041,
    opacity: 0.86,
    strokeWidth: 0.19811
  }), /*#__PURE__*/React.createElement("rect", {
    x: -362.44,
    y: 106.97,
    width: 193.81,
    height: 128.36,
    ry: 49.463,
    opacity: 0.86,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -274.35,
    cy: 159.83,
    rx: 66.699,
    ry: 35.237,
    opacity: 0.86,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.77,
    y: 49.234,
    width: 82.57,
    height: 54.802,
    ry: 2.9358,
    opacity: 0.86,
    strokeWidth: 0.19842
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -59.424,
    cy: 22.695,
    rx: 31.47,
    ry: 22.072,
    fill: "#c8b7b7",
    fillRule: "evenodd",
    strokeWidth: 0.19811
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m86.261 16.865 3.4752-15.825-16.218 7.9127z",
    fillOpacity: 0,
    opacity: 0.86,
    strokeWidth: 0.19842
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 117.98 -83.435)",
    fill: "#c8b7b7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.633 99.88-2.7029-15.409 20.079 7.4963z",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.484 99.255 2.703-15.409-20.079 7.4963z",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.821,
    cy: 129.03,
    rx: 8.1089,
    ry: 17.075,
    fillRule: "evenodd",
    strokeWidth: 0.19811
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.177,
    cy: 136.11,
    rx: 19.693,
    ry: 14.16,
    fillRule: "evenodd",
    strokeWidth: 0.19811
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.455 115.29 6.1782 5.8304 9.6534 2.0823 1.5445 7.9127-18.921-7.0798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.623 140.69c1.7809-1.5988 3.3378-3.439 5.1684-4.9806s4.026-2.8019 6.4157-2.9322c1.5245-0.0831 3.0531 0.303 4.4259 0.97109s2.598 1.6107 3.7047 2.6626c2.2133 2.1036 3.9713 4.645 6.1564 6.7778 0.61095 0.59632 1.2602 1.1638 2.0033 1.584 0.74316 0.42022 1.5899 0.68835 2.4428 0.65013 0.42644-0.0191 0.8508-0.11519 1.2375-0.29596 0.38671-0.18076 0.73502-0.44715 0.99871-0.78284 0.2637-0.33568 0.44106-0.74108 0.49344-1.1647 0.0524-0.42365-0.0225-0.8644-0.22529-1.24-0.22998-0.42597-0.61132-0.75275-1.0237-1.0063-0.41237-0.25356-0.86045-0.44245-1.2931-0.65952-2.3767-1.1923-4.2246-3.1937-6.1782-4.9975-2.6179-2.4171-5.5516-4.5614-8.8811-5.8304-1.4887-0.56739-3.0574-0.95657-4.6498-1.0049-1.5924-0.0484-3.2119 0.25482-4.6174 1.0049-1.4635 0.78108-2.6353 2.0043-3.7483 3.2344s-2.2116 2.5034-3.5883 3.4289c-1.0212 0.68648-2.1938 1.1813-3.0379 2.0765-0.42206 0.44763-0.75254 0.99765-0.86159 1.6031-0.05452 0.30275-0.05276 0.61668 0.01656 0.91638 0.06932 0.29971 0.20706 0.58473 0.4077 0.81791 0.28647 0.33292 0.69489 0.55088 1.1252 0.63887 0.4303 0.088 0.88102 0.0506 1.3027-0.072 0.84344-0.2454 1.5521-0.8129 2.2057-1.3997z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 117.98 -83.435)",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.9 114.04c-4.2473 0.27784-12.742 1.6658-12.742 1.6658z",
    strokeWidth: ".19811px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.661 117.83-11.947 4.4964z",
    strokeWidth: ".25864px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.613 112.07 14.268 3.1121z",
    strokeWidth: ".34322px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.22 114.88 10.42 5.4016z",
    strokeWidth: ".20984px"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 74.062 -61.74)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.54415,
    cy: 83.184,
    rx: 6.5614,
    ry: 5.8273,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.801,
    cy: 82.764,
    rx: 6.5614,
    ry: 5.8273,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a05a2c",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.79,
    y: 167.07,
    width: 22.967,
    height: 61.493,
    rx: 11.484,
    ry: 5.2572
  }))), /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -73.432,
    cy: 21.121,
    rx: 3.6103,
    ry: 2.8865,
    strokeWidth: 0.21247
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -47.178,
    cy: 20.731,
    rx: 3.6103,
    ry: 2.8865,
    strokeWidth: 0.21247
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatRight);
export default __webpack_public_path__ + "static/media/cat_right.383f08fc390a8846e458cc88d439df47.svg";
export { ForwardRef as ReactComponent };